/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalid_Vimeo_UrlInputs */

const en_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid Vimeo URL`)
};

const es_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de Vimeo no válida`)
};

const fr_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Vimeo invalide`)
};

const de_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültige Vimeo-URL`)
};

const ja_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なVimeo URL`)
};

const zh_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无效的 Vimeo 链接`)
};

const ar_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط Vimeo غير صالح`)
};

const id_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Vimeo tidak valid`)
};

const it_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Vimeo non valido`)
};

const ru_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недействительный URL-адрес Vimeo`)
};

const pt_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do Vimeo inválido`)
};

const ko_invalid_vimeo_url = /** @type {(inputs: Invalid_Vimeo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘못된 Vimeo URL`)
};

/**
* | output |
* | --- |
* | "Invalid Vimeo URL" |
*
* @param {Invalid_Vimeo_UrlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const invalid_vimeo_url = /** @type {((inputs?: Invalid_Vimeo_UrlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalid_Vimeo_UrlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalid_vimeo_url(inputs)
	if (locale === "es") return es_invalid_vimeo_url(inputs)
	if (locale === "fr") return fr_invalid_vimeo_url(inputs)
	if (locale === "de") return de_invalid_vimeo_url(inputs)
	if (locale === "ja") return ja_invalid_vimeo_url(inputs)
	if (locale === "zh") return zh_invalid_vimeo_url(inputs)
	if (locale === "ar") return ar_invalid_vimeo_url(inputs)
	if (locale === "id") return id_invalid_vimeo_url(inputs)
	if (locale === "it") return it_invalid_vimeo_url(inputs)
	if (locale === "ru") return ru_invalid_vimeo_url(inputs)
	if (locale === "pt") return pt_invalid_vimeo_url(inputs)
	return ko_invalid_vimeo_url(inputs)
});